import TableReportHelper from "report/helper"
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport"
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport"
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport"
import PSMApontamentoColetasLocalizacaoReport from "./PSMApontamentoColetasLocalizacaoReport"

export default async function PSMReport(indicador, visita) {
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor
    const apontamentos = visita.getApontamentosByIndicador(indicador)
    const content = []

    for (const apontamento of apontamentos) {
        // let showObservacao = false // removido para o indicador pragaSolo
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const configIndicador = {
            showTrator: false,
            showImplemento: false,
            showFrente: false,
            addHeaderField: [
                {
                    field: "talhao.area", label: "Área do Talhão (ha)", width: 90, valueGetter: (a) => {
                        let sumArea = 0

                        if (a.talhao.length) {
                            for (let i = 0; i < a.talhao.length; i++) {
                                sumArea = sumArea + parseFloat(a.talhao[i].area)
                            }

                            return sumArea.toFixed(2)
                        } else {
                            return a.talhao.area
                        }
                    },
                },
                { field: "totalTocosAvaliados", label: "Total de Tocos Avaliados", width: 70 },
                { field: "totalTocosAtacados", label: "Total de Tocos Atacados", width: 70 },
            ]
        }

        content.push(
            [
                await apontamentoHeaderLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    params,
                    "", // label da conformidade
                    configIndicador,
                    null,
                    false // showConformidade
                ),

                await PSMApontamentoColetasLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    true // showObservacao
                ),
                apontamentoImagesReport(visita, indicador, apontamento),
                apontamentoObservacaoReport(visita, indicador, apontamento),

                h.space(),
            ]
        )
    }

    return content
}
